import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    id: 0,
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    cuentaNumero: '',
    cbu: '',
    cbuAlias: '',
    inactivo: false,
    rowVersion: null,
    
    /* Para validar el CBU (si es Arg) */
    bancoPaisId: 0,

    bancoCuentaDatos: [],
    bancoCuentaSaldos: [],
    readonly: false
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_CUENTA'(state, bancoCuentaId) {
        state.id = bancoCuentaId;
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.monedaId = 0;
        state.moneda = null;
        state.monedaNombre = null;
        state.cuentaNumero = '';
        state.cbu = '';
        state.cbuAlias = '';
        state.inactivo = false;
        state.rowVersion = null;

        state.bancoPaisId = 0; 
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoId = bancoCuenta.banco? bancoCuenta.banco.id : 0;
        state.banco = bancoCuenta.banco;
        state.bancoNombre = bancoCuenta.banco? bancoCuenta.banco.nombre.trim() : null;
        state.cuentaNumero = bancoCuenta.cuentaNumero.toUpperCase().trim();
        state.monedaId = bancoCuenta.moneda? bancoCuenta.moneda.id : 0;
        state.moneda = bancoCuenta.moneda;
        state.monedaNombre = bancoCuenta.moneda? bancoCuenta.moneda.nombre.trim() : null;
        state.cbu = bancoCuenta.cbu.trim();
        state.cbuAlias = bancoCuenta.cbuAlias.trim();
        state.inactivo = bancoCuenta.inactivo;
        state.rowVersion = bancoCuenta.rowVersion;

        state.bancoPaisId = bancoCuenta.banco? bancoCuenta.banco.paisId : 0;
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;

        if (banco) {
            state.bancoId = banco.id? banco.id : 0;
            state.bancoNombre = banco.nombre? banco.nombre.trim() : null;
            state.bancoPaisId = banco.paisId? banco.paisId : 0;
        } else {
            state.bancoId = 0;
            state.bancoNombre = null;
            state.bancoPaisId = 0;
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;

        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.monedaNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },

    'INICIALIZAR_BANCO_CUENTA_DATOS' (state) {
        state.bancoCuentaDatos = [];
        state.readonly = false;
    },
    'SET_BANCO_CUENTA_DATOS' (state, params) {
        state.bancoCuentaDatos = params.bancoCuentaDatos;
        state.readonly = params.readonly;
    },

    'INICIALIZAR_BANCO_CUENTA_SALDOS' (state) {
        state.bancoCuentaSaldos = [];
    },
    'SET_BANCO_CUENTA_SALDOS' (state, params) {
        state.bancoCuentaSaldos = params.bancoCuentaSaldos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoCuentaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CUENTA', bancoCuentaId);

            if (bancoCuentaId != 0) {
                apiAxios.get(`bancoscuentas/${bancoCuentaId}/abm` ) 
                    .then(res => {
                        commit('SET_BANCO_CUENTA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let bancoCuenta = {
                bancoId: parseInt(state.bancoId),
                monedaId: parseInt(state.monedaId),
                cuentaNumero: state.cuentaNumero.trim(),
                cbu: state.cbu.trim(), 
                cbuAlias: state.cbuAlias.trim().toUpperCase(),
                inactivo: state.inactivo,
            }

            let url = 'bancoscuentas';
            if (state.id != 0) {
                bancoCuenta.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, bancoCuenta)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        })
    },
    setBanco: ({commit}, banco) => {
        commit('SET_BANCO', banco);
    },
    setMoneda: ({commit}, moneda) => {
        commit('SET_MONEDA', moneda);
    },

    getBancoCuentaDatos ( { commit }, bancoCuentaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CUENTA_DATOS');

            if (bancoCuentaId != 0) {
                apiAxios.get(`bancoscuentas/${bancoCuentaId}` ) 
                .then(res => {
                    let bancoCuentaDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                        { 'nombre': 'moneda', 'campo': 'Moneda', 'valor': res.data.moneda, 'formato': '' },
                        { 'nombre': 'cuentaNumero', 'campo': 'Nro. Cuenta', 'valor': res.data.cuentaNumero, 'formato': '' },
                        { 'nombre': 'cbu', 'campo': 'CBU', 'valor': res.data.cbu, 'formato': '' },
                        { 'nombre': 'cbuAlias', 'campo': 'CBU Alias', 'valor': res.data.cbuAlias, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        bancoCuentaDatos,
                        readonly: (/true/i).test(res.data.readonly)
                    }
                    commit('SET_BANCO_CUENTA_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    getSaldoBancoCuenta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CUENTA_SALDOS');

            if (params.bancoCuentaId != 0) {
                let queryString = '?fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

                apiAxios.get(`bancoscuentas/${params.bancoCuentaId}/saldo` + queryString) 
                    .then(res => {
                        const saldo = helpers.methods.formattedMoneda(res.data.saldo, res.data.monedaAbreviacion);
                        const saldoPropio = helpers.methods.formattedMoneda(res.data.saldoPropio, res.data.monedaAbreviacion);

                        let bancoCuentaSaldos = [
                            { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                            { 'nombre': 'moneda', 'campo': 'Moneda', 'valor': res.data.moneda, 'formato': '' },
                            { 'nombre': 'cuentaNumero', 'campo': 'Nro. Cuenta', 'valor': res.data.cuentaNumero, 'formato': '' },
                            { 'nombre': 'cbu', 'campo': 'CBU', 'valor': res.data.cbu, 'formato': '' },
                            { 'nombre': 'saldo', 'campo': 'Saldo', 'valor': saldo, 'formato': '' },
                            { 'nombre': 'saldoPropio', 'campo': 'Saldo Propio', 'valor': saldoPropio, 'formato': '' },
                        ];

                        let params = {
                            bancoCuentaSaldos
                        }

                        commit('SET_BANCO_CUENTA_SALDOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}